var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.0005 2.49988C5.85835 2.49988 2.50049 5.85774 2.50049 9.99988C2.50049 14.142 5.85835 17.4999 10.0005 17.4999C14.1426 17.4999 17.5005 14.142 17.5005 9.99988C17.5005 5.85774 14.1426 2.49988 10.0005 2.49988ZM9.99954 5.62488C10.5175 5.62488 10.9373 6.04473 10.9373 6.56265C10.9373 7.08057 10.5175 7.50043 9.99954 7.50043C9.48162 7.50043 9.06177 7.08057 9.06177 6.56265C9.06177 6.04473 9.48162 5.62488 9.99954 5.62488ZM9.06082 8.74988C8.5429 8.74988 8.12305 9.16973 8.12305 9.68765C8.12305 10.2056 8.5429 10.6254 9.06082 10.6254L9.06211 14.0628C9.06244 14.5804 9.48216 14.9999 9.99979 14.9999C10.5177 14.9999 10.9375 14.5801 10.9375 14.0622L10.9364 9.68765C10.9364 9.16973 10.5165 8.74988 9.9986 8.74988H9.06082Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "9c50aec28ed86837ef4d8e6d651dbf06.svg";
export { ForwardRef as ReactComponent };